import { jsx } from 'react/jsx-runtime';
import { createContext, useContext } from 'react';

const HeadingLevelContext = createContext({
  level: 1
});
const useHeadingLevel = () => useContext(HeadingLevelContext);
const HeadingLevelProvider = ({ level = 1, children }) => {
  return jsx(HeadingLevelContext.Provider, { value: {
    level
  }, children });
};

export { HeadingLevelProvider, useHeadingLevel };
//# sourceMappingURL=HeadingLevelContext.es.js.map
